

































import { Vue, Component, Watch } from "vue-property-decorator";
import { Contractor as IContractor } from "@/api/models/contractor";
import contractors, { ContractorsListParams } from "@/getinfo-api/contractors";
import { uniqBy } from "lodash";

@Component
export default class SearchContractor extends Vue {
  search!: string;
  processing: boolean = false;
  contractors!: Array<IContractor>;
  data() {
    return {
      search: undefined,
      contractors: undefined
    };
  }

  entityHandler(contractor: IContractor) {
    this.$emit("entityContractor", contractor);
  }

  @Watch("search")
  showSpinner() {
    if (this.search && this.search.length > 2) {
      this.processing = true;
    }
  }

  @Watch("search")
  searchContractor() {
    if (this.search && this.search.length > 2) {
      this.contractors = [];
      let allParams = [];
      let title: ContractorsListParams = {
        title: this.search
      };
      let shortTitle: ContractorsListParams = {
        shortTitle: this.search
      };
      let inn: ContractorsListParams = {
        inn: this.search
      };
      allParams.push(title, shortTitle, inn);
      allParams.forEach(element => {
        contractors(element).then((res: { data: any }) => {
          if (res.data.items && res.data.items.length > 0) {
            res.data.items.forEach((item: any) => {
              this.contractors.push(item);
            });
            this.contractors = uniqBy(this.contractors, "id");
          }
          this.processing = false;
        });
      });
    }
  }
}
